import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Pagination from 'react-js-pagination';
import { ReactComponent as PageLeftEndIcon } from 'assets/icons/page_left_end.svg';
import { ReactComponent as PageLeftIcon } from 'assets/icons/page_left.svg';
import { ReactComponent as PageRightEndIcon } from 'assets/icons/page_right_end.svg';
import { ReactComponent as PageRightIcon } from 'assets/icons/page_right.svg';
import styles from 'styles/components/common/nav/Paging.module.scss';
import { DEFAULT_PAGE_SIZE } from 'constants/page';

type TProps = {
  activePage?: number;
  itemCountPerPage?: number;
  totalItemsCount?: number;
  handlePageChange: React.Dispatch<number>;
};

const Paging = ({
  activePage = 1,
  itemCountPerPage = DEFAULT_PAGE_SIZE,
  totalItemsCount = 450,
  handlePageChange,
}: TProps) => {
  const pageRangeDisplayed = 5;

  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  useEffect(() => {
    query.set('size', itemCountPerPage.toString());
    query.set('page', activePage.toString());

    navigate({
      search: query.toString(),
    });
  }, [location.search, activePage]);

  return (
    <div className={styles.paging_wrapper}>
      <Pagination
        activePage={activePage}
        itemsCountPerPage={itemCountPerPage}
        totalItemsCount={totalItemsCount}
        pageRangeDisplayed={pageRangeDisplayed}
        firstPageText={
          <button className="pagingIconButton" disabled={activePage === 1}>
            <PageLeftEndIcon width={24} height={24} />
          </button>
        }
        prevPageText={
          <button className="pagingIconButton" disabled={activePage === 1}>
            <PageLeftIcon width={24} height={24} />
          </button>
        }
        nextPageText={
          <button
            className="pagingIconButton"
            disabled={
              activePage === Math.ceil(totalItemsCount / itemCountPerPage)
            }
          >
            <PageRightIcon width={24} height={24} />
          </button>
        }
        lastPageText={
          <button
            className="pagingIconButton"
            disabled={
              activePage === Math.ceil(totalItemsCount / itemCountPerPage)
            }
          >
            <PageRightEndIcon width={24} height={24} />
          </button>
        }
        onChange={handlePageChange}
      />
    </div>
  );
};

export default Paging;
